module.exports = __webpack_public_path__ + "assets/webgl/art_069_L0.jpg.pvr.bab51689.ktx";